/**
 * Product Ingredients Section
 * Swiper carousel with hover interactions
 */

class ProductIngredients extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.swiperEl = null;
    this.prevBtn = null;
    this.nextBtn = null;
    this.pagination = null;
    this.boundInitSwiper = this.initSwiper.bind(this);
    this.boundUpdateNavigation = this.updateNavigation.bind(this);
    this.boundCheckOverflow = this.checkOverflow.bind(this);
  }

  connectedCallback() {
    this.swiperEl = this.querySelector('.product-ingredients__slider');
    this.prevBtn = this.querySelector('.swiper-nav__arrow--prev');
    this.nextBtn = this.querySelector('.swiper-nav__arrow--next');
    this.pagination = this.querySelector('.swiper-nav__pagination');

    if (this.swiperEl && typeof Swiper !== 'undefined') {
      this.initSwiper();
    } else if (this.swiperEl) {
      document.addEventListener('DOMContentLoaded', this.boundInitSwiper);
    }

    this.checkOverflow();
    window.addEventListener('resize', this.boundCheckOverflow);
  }

  checkOverflow() {
    const cards = this.querySelectorAll('.product-ingredients__card');
    cards.forEach(card => {
      const content = card.querySelector('.product-ingredients__content');
      const description = card.querySelector('.product-ingredients__card-description');
      const scrollbar = card.querySelector('.product-ingredients__scrollbar');
      const track = card.querySelector('.product-ingredients__scrollbar-track');

      if (!description || !content) return;

      const lineHeight = parseFloat(window.getComputedStyle(description).lineHeight) || 22;
      const maxLines = 3;
      const maxHeight = lineHeight * maxLines;

      if (description.scrollHeight > maxHeight + 2) {
        card.classList.add('has-overflow');
        this.setupScrollbar(card, content, scrollbar, track);
      } else {
        card.classList.remove('has-overflow');
      }
    });
  }

  setupScrollbar(card, content, scrollbar, track) {
    if (!scrollbar || !track) return;

    const scrollbarHeight = 114;

    const updateTrack = () => {
      const contentHeight = content.scrollHeight;
      const visibleHeight = content.clientHeight;
      const scrollTop = content.scrollTop;
      const scrollRange = contentHeight - visibleHeight;

      if (scrollRange <= 0) {
        track.style.height = scrollbarHeight + 'px';
        track.style.top = '0px';
        return;
      }

      const trackHeight = Math.max(30, (visibleHeight / contentHeight) * scrollbarHeight);
      const trackRange = scrollbarHeight - trackHeight;
      const trackTop = (scrollTop / scrollRange) * trackRange;

      track.style.height = trackHeight + 'px';
      track.style.top = trackTop + 'px';
    };

    content.removeEventListener('scroll', updateTrack);
    content.addEventListener('scroll', updateTrack);

    card.addEventListener('mouseenter', () => {
      setTimeout(updateTrack, 50);
    });
  }

  initSwiper() {
    if (this.swiper) return;

    const slidesPerViewDesktop = parseInt(this.dataset.slidesDesktop) || 3;
    const spaceBetweenDesktop = parseInt(this.dataset.gapDesktop) || 18;
    const spaceBetweenMobile = parseInt(this.dataset.gapMobile) || 6;

    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: spaceBetweenMobile,
      grabCursor: true,
      watchOverflow: true,
      pagination: {
        el: this.pagination,
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active'
      },
      navigation: {
        prevEl: this.prevBtn,
        nextEl: this.nextBtn
      },
      breakpoints: {
        750: {
          slidesPerView: slidesPerViewDesktop,
          spaceBetween: spaceBetweenDesktop
        }
      },
      on: {
        init: this.boundUpdateNavigation,
        slideChange: this.boundUpdateNavigation
      }
    });
  }

  updateNavigation() {
    if (!this.swiper || !this.prevBtn || !this.nextBtn) return;

    this.prevBtn.disabled = this.swiper.isBeginning;
    this.nextBtn.disabled = this.swiper.isEnd;
  }

  disconnectedCallback() {
    document.removeEventListener('DOMContentLoaded', this.boundInitSwiper);
    window.removeEventListener('resize', this.boundCheckOverflow);

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('product-ingredients')) {
  customElements.define('product-ingredients', ProductIngredients);
}
